<div
  class="search-result-active-errors__container flex flex-row gap-[8px] justify-end items-stretch"
>
  <button
    mat-stroked-button
    class="mat-button--edgy"
    data-at-submenu="control"
    [matMenuTriggerFor]="controlSubMenu"
    [disabled]="!errors || !errors.length"
    gtm="onShow"
    gtmAction="Active errors dropdown"
    gtmCategory="gatewaySearch"
  >
    <span>{{ '+SEARCH.RESULT_LIST.ACTIVE_ERRORS.LIST_TITLE' | translate }}</span>
    <mat-icon>keyboard_arrow_down</mat-icon>
  </button>
  <mat-menu #controlSubMenu="matMenu">
    <div mat-menu-item class="search-result-active-errors__menu-item" *ngFor="let error of errors">
      {{ error.content.errorCode }}
    </div>
  </mat-menu>
  <button
    mat-stroked-button
    color="primary"
    (click)="openDialog()"
    [disabled]="!errors || !errors.length"
    gtm="onOpen"
    gtmAction="Active errors popup"
    gtmCategory="gatewaySearch"
  >
    <span>{{ '+SEARCH.RESULT_LIST.ACTIVE_ERRORS.SHOW' | translate }}</span>
    <mat-icon>arrow_forward</mat-icon>
  </button>
</div>
